import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IProductCommissionList, IProductCommissionListWithAnalytics } from "./models/prodcuts-commissions";
import moment from "moment/moment";

@Injectable({
  providedIn: "root",
})
export class ProductsCommissionsService {
  private baseUrl: string = "/commission-product";
  constructor(private _httpClient: HttpClient) {}

  async getCommissions(year: number = moment().year()) {
    return this._httpClient.get<IProductCommissionList[]>(`/commission-product?year=${year}`).toPromise();
  }

  async getCommission(id: number) {
    return this._httpClient.get(`${this.baseUrl}/${id}`).toPromise();
  }

  async addCommission(data: any = {}) {
    return this._httpClient.post(this.baseUrl, data).toPromise();
  }

  async editCommission(id: number, data: any = {}) {
    return this._httpClient.put(`${this.baseUrl}/${id}`, data).toPromise();
  }

  async deleteCommission(id: number) {
    return this._httpClient.delete(`${this.baseUrl}/${id}`).toPromise();
  }

  //Function for reopen or close a commission
  async editStatusCommission(id: number, data: any = {}) {
    return this._httpClient.put(`${this.baseUrl}/status/${id}`, data).toPromise();
  }

  async getCommissionsListWithAnalytics(product_id: number) {
    return this._httpClient.get<IProductCommissionListWithAnalytics[]>(`/product/commission/${product_id}`).toPromise();
  }
}
